// Generated by scripts/build-ui-icons.mjs.
export { FunnelSimple as default } from "../ui/glyphs-4";
